import React, { useEffect, useLayoutEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import DefaultFooter from "../CommonUtils/DefaultFooter";
import HWLog from "../HWLibrary/HWLog";
import HWUser from "../HWLibrary/HWUser";

import ConversationList from "./ConversationList";
import LandingPageHeader from "./LandingPageHeader";
import { useNetworkStatus } from "../../context/NetworkContext";
import "../LandingPage/LandingPageStyleSheet.css";
import { PageName } from "../Simplify360Chat";
import apiService from "../Services/APIService";
import { s360ConfigService } from "../Services/S360Config";
import NCXChatHistory from "../Conversation/NCXChatHistory";
import {
  findFirstActiveObject,
  getCookieForContactDetails,
} from "../Conversation/utils/ConversationUtils";
import NetworkStatusPopup from "../Conversation/MessageBoxTypes/NCXComponents/NetworkStatusPopup";

function LandingPage(props) {
  const { isOnline, networkQuality, latency } = useNetworkStatus();
  const [networkReloaded, setNetworkReloaded] = useState(false);
  const [agentsList, setAgentsList] = useState([]);
  const [healthPings] = useState({});
  const [areAllPreviousSessionsClosed, setAreAllPreviousSessionsClosed] =
    useState(false);
  const [conversations, setConversations] = useState([]);
  const [isFetchingConversations, setIsFetchingConversations] = useState(false);
  const [activeSession, setActiveSession] = useState(null);

  let chatStatus = {
    Active: "Active",
    New: "New",
    Previous: "Previous",
  };
  // var moveToNewConversation = false;
  let hideHistory = s360ConfigService.getConfig().anonymous
    ? true
    : props.config.hideChatHis;
  let lastFetchedSessionListCount = 0;
  console.log(hideHistory, "hideHistory");
  const initialize = async () => {};

  useEffect(() => {
    console.log(s360ConfigService?.config?.hideChatHis, isOnline);
    // console.log(s360ConfigService?.config?.anonymous);
    if (s360ConfigService?.config?.anonymous) {
      let cookieForContactDetails = getCookieForContactDetails(
        s360ConfigService.config.widgetconfigId
      );

      if (cookieForContactDetails) {
        apiService
          .getTicketsListHistory(cookieForContactDetails)
          .then(async (his) => {
            s360ConfigService.chatHistory = his.data;

            // Call the async function and await its result
            s360ConfigService.activeConversation = await findFirstActiveObject(
              s360ConfigService.chatHistory
            );

            if (s360ConfigService.activeConversation) {
              s360ConfigService.resumedWorkitemId =
                s360ConfigService.activeConversation;
              props.actions.moveToPage(PageName.conversationPage);
            } else {
              if (isOnline) {
                props.actions.startNewConversation();
                props.actions.moveToPage(PageName.conversationPage);
              }
            }
          });
      } else {
        if (isOnline) {
          props.actions.startNewConversation();
        }
      }
    } else if (s360ConfigService?.config?.hideChatHis) {
      if (!isOnline) {
        props.actions.moveToPage(PageName.conversationPage);
        return;
      } else {
        props.actions.startNewConversation();
        props.actions.moveToPage(PageName.conversationPage);
      }
    }
  }, []);

  const landingPageActions = {
    createNewSessionCometd: () => {
      createNewSessionCometd();
    },
    openHistoryConversation: (session, isActive) => {
      props.actions.startConversation(session, isActive, true);
    },
    resumeConversation: (session, isActive, ticketId) => {
      s360ConfigService.config.isNewConversation = true;
      s360ConfigService.config.anonymousClosed = false;
      props.actions.setActiveConversation({
        workitemId: session,
        ticketId: ticketId,
      });

      props.actions.startInitChatWSConnection(session);

      props.actions.moveToPage(PageName.conversationPage);
    },
    startNewConversation: () => {
      props.actions.startNewConversation();
      props.actions.moveToPage(PageName.conversationPage);
    },
    downloadHistory: (ticketId, workItemId) => {
      props.actions.downloadHistory(ticketId, workItemId);
    },
  };

  const createNewSessionCometd = () => {};

  const openHistoryConversation = (session) => {
    localStorage.removeItem("selectedLanguage");
    if (session !== null && session !== undefined) {
      if (session.active) {
        let sessionToBePassed = session;
        sessionToBePassed.sessionStatus = chatStatus.Active;

        props.actions.startConversation(sessionToBePassed);
      } else {
        let sessionToBePassed = session;
        sessionToBePassed.sessionStatus = chatStatus.Previous;
        sessionStorage.removeItem("agentName");
        props.actions.startConversation(sessionToBePassed);
      }
    } else {
      createNewSessionCometd();
    }
  };

  const onSessionsListResponseCometd = (message) => {
    if (!message.listSessionInfo || message.listSessionInfo.length === 0) {
      lastFetchedSessionListCount = 0;

      setIsFetchingConversations(false);

      if (props.config.hideChatHis) {
        openHistoryConversation();
      }
      return;
    } else {
      // setSessionsList(message.listSessionInfo);
    }

    let conversationIds = conversations.map((i) => i.sessionId);
    let newConversations = message.listSessionInfo.filter(
      (i) => conversationIds.indexOf(i.sessionId) === -1
    );
    lastFetchedSessionListCount = newConversations.length;

    let firstActiveConversation = [...newConversations].find(
      (conversation) => conversation.active
    );
    if (firstActiveConversation) {
      setActiveSession(firstActiveConversation);
      if (firstActiveConversation.agentInfo?.firstName) {
        let agentNameTemp =
          firstActiveConversation.agentInfo.firstName +
          " " +
          firstActiveConversation.agentInfo.lastName;
        sessionStorage.setItem("agentName", agentNameTemp.trim());
      }
    }

    if (props.config.hideChatHis) {
      if (firstActiveConversation) {
        //TODO:AUTOMATICALLY MOVE TO CONVERSATION PAGE WITH NEW SESSION ID
        props.actions.startConversation(firstActiveConversation);
      } else {
        openHistoryConversation();
      }
    } else {
      setIsFetchingConversations(false);
      setConversations(
        props.config.configDetails.showPreviousSession
          ? [...conversations, ...newConversations]
          : firstActiveConversation
          ? [firstActiveConversation]
          : []
      );
      setAreAllPreviousSessionsClosed(
        newConversations.every((conversation) => !conversation.active)
      );
    }
  };

  const onCreateSessionResponseCometd = (newSessionResponse) => {
    newSessionResponse.sessionStatus = chatStatus.New;

    sessionStorage.removeItem("agentConnected");
    sessionStorage.removeItem("agentName");
    props.actions.startConversation(newSessionResponse);
  };

  const parseUniboxSingleRefresh = function () {
    props.uniboxSingleRefreshChange();
  };

  // Parse Agents List Response.
  const onAgentListResponse = (message) => {
    HWLog.info("PARSED AGENTS LIST MESSAGES", message);
    if (!message?.listAgentInfo || message?.listAgentInfo.length === 0) {
      HWLog.info("EMPTY AGENTS LIST");
      return;
    }
    setAgentsList(message.listAgentInfo);
  };

  //   GREEN - Online
  //   RED - Offline
  //   Yellow - Away
  const parseAgentStatusPingResponse = (message) => {
    let sessionId = message.sessionId || "";
    let status = (message.onlineStatus && message.onlineStatus.status) || "";
    let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
    if (!isValidStatus) {
      HWLog.info("Invlaid Ping Status From Server: ", message || {});
      return;
    }

    let conversations = (conversations || []).map((conversation) => {
      if (conversation.sessionId === sessionId) {
        conversation.active = status === "GREEN";
      }
      return conversation;
    });
    setConversations(conversations);
    HWLog.info("AGENT PING STATUS: " + status);
  };

  // MARK: Handle Session Pagination
  const onConversationScrollToBottom = () => {
    HWLog.info("SCROLLED TO BOTTOM:" + lastFetchedSessionListCount);
    if (lastFetchedSessionListCount === 0) {
      return;
    }
    fetchNextPageConversations();
  };

  const fetchNextPageConversations = () => {
    if (isFetchingConversations) {
      return;
    }
    let conversations = conversations || [];
    if (conversations.length === 0) {
      return;
    }
    setIsFetchingConversations(false);
  };

  return (
    <>
      {hideHistory && (
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <div style={{ textAlign: "center", paddingTop: "38vh" }}>
            <CircularProgress color="inherit" size={20} />
          </div>
        </div>
      )}
      {!hideHistory && (
        <div className="s360-conversation-list-view-container">
          <LandingPageHeader
            agentsList={agentsList}
            healthPings={healthPings}
            areAllPreviousSessionsClosed={areAllPreviousSessionsClosed}
            conversations={conversations}
            isFetchingConversations={isFetchingConversations}
            activeSession={activeSession}
            {...props}
          />
          <div className="s360-conversation">
            {!hideHistory && (
              <NCXChatHistory
                isAppOpen={props.isAppOpen}
                isOnline={isOnline}
                userFromLanding
                landingPageActions={landingPageActions}
              />
            )}
          </div>
          <NetworkStatusPopup onReload={() => window.location.reload()} />
          <DefaultFooter {...props} />
        </div>
      )}
    </>
  );
}

export default LandingPage;
